<script lang="ts" setup>
import { GInline } from '@flash-global66/g-inline';
import { GIconFont } from '@flash-global66/g-icon-font';
import { GTooltip } from '@flash-global66/g-tooltip';
import { useQuoterSLAMessage } from './useQuoterSLAMessage';

defineOptions({ name: 'QuoterSLAMessage' });

const props = defineProps({
  estimatedSla: {
    type: String,
    default: '',
  },
  customerMessage: {
    type: String,
    default: '',
  },
  isAch: {
    type: Boolean,
    default: false,
  },
  immediate: {
    type: Boolean,
    default: false,
  },
  minutesDate: {
    type: Boolean,
    default: false,
  },
  shortTime: {
    type: Boolean,
    default: false,
  }
});

const { message } = useQuoterSLAMessage(props);

</script>

<template>
  <GInline
    hide-close
    icon="regular timer"
  >
    <div class="flex items-center gap-xs">
      <p v-html="message" />
      <GTooltip
        v-if="isAch"
        raw-content
        :content="`
        • Los tiempos de envío varían según horarios bancarios.<br/>
        • Para conocer más sobre los horarios bancarios, ve al siguiente <a class='underline' href='https://bases.global66.com/wp-content/uploads/2023/07/tarifario-b2c-co-18-07.pdf' target='_blank' >enlace<a/>.`">
        <GIconFont name="solid question-circle" />
      </GTooltip>
    </div>
  </GInline>
</template>
